import { MEDIA_QUERIES } from "@constants"
import styled from "styled-components"

export const PricingPlanCardDIV = styled.div`
  // Free plan color
  --Plan--gradient-color: var(--color--clay-100-rgb);
  --Plan--radial-gradient-color: var(--color--clay-400-rgb);
  --Plan--border-radius: var(--border-radius--M);
  --Plan--border-padding: 6px;
  --Plan--gradient-border-radius: calc(var(--border-radius--L) * 0.4);

  border-radius: var(--Plan--border-radius) var(--Plan--border-radius) 0 0;
  border: 1px solid rgba(var(--color--cobalt-900-rgb), 0.08);
  box-shadow: var(--elevation--XS);
  display: flex;
  flex-direction: column;
  gap: var(--spacing--S);
  justify-content: space-between;
  padding: var(--spacing--S) var(--spacing--XS);
  position: relative;
  z-index: 1;

  &.hide-button {
    justify-content: flex-start;
  }

  &.plan--standard {
    --Plan--gradient-color: var(--color--green-100-rgb);
    --Plan--radial-gradient-color: var(--color--green-400-rgb);
    --Plan--border-radius: var(--border-radius--M);
  }

  &.plan--plus {
    --Plan--gradient-color: var(--color--cobalt-100-rgb);
    --Plan--radial-gradient-color: var(--color--cobalt-400-rgb);
  }

  &.plan--pro {
    --Plan--gradient-color: var(--color--purple-100-rgb);
    --Plan--radial-gradient-color: var(--color--purple-400-rgb);
  }

  ${MEDIA_QUERIES.M} {
    padding: var(--spacing--base-2-5) var(--spacing--base-2);
  }

  .gradient-background {
    height: 120%;
    left: var(--Plan--border-padding);
    opacity: 0.5;
    position: absolute;
    top: var(--Plan--border-padding);
    width: calc(100% - (var(--Plan--border-padding) * 2));
    z-index: 1;

    &,
    &::before,
    &::after {
      border-radius: calc(var(--Plan--border-radius) * 0.75);
    }

    &::before,
    &::after {
      content: "";
      display: block;
      background:
        url("/images/noise-overlay.png"),
        radial-gradient(circle at 100% 0%, rgba(var(--Plan--radial-gradient-color), 0.45) 0%, rgba(var(--Plan--radial-gradient-color), 0) 33.3333%),
        rgba(var(--Plan--gradient-color), 1);
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }

    &::before {
      border: 0.5px solid rgba(var(--color--cobalt-900-rgb), 0.05);
      z-index: 1;
    }

    &::after {
      background: linear-gradient(180deg, rgba(var(--color--basics-white-rgb), 0), rgba(var(--color--basics-white-rgb), 1));
      z-index: 2;
    }
  }

  &::before {
    content: "";
    display: block;
    background: linear-gradient(to right, rgb(var(--Plan--gradient-color)), rgb(var(--Plan--radial-gradient-color)));
    border-radius: var(--Plan--gradient-border-radius) var(--Plan--gradient-border-radius) 0 0;
    height: var(--Plan--border-padding);
    left: var(--Plan--border-padding);
    position: absolute;
    top: var(--Plan--border-padding);
    width: calc(100% - var(--Plan--border-padding) * 2);
  }

  &::after {
    background: linear-gradient(to top, rgba(var(--color--basics-white-rgb), 1) 10%, rgba(var(--color--basics-white-rgb), 0) 100%);
    bottom: -8px;
    content: "";
    display: block;
    height: calc(100% + 4px);
    left: -4px;
    position: absolute;
    width: calc(100% + 8px);
    z-index: 0;
  }

  > h4,
  > p,
  > .Button {
    position: relative;
    z-index: 2;
  }

  > p {
    text-wrap: balance;
  }
`
